import React from 'react';
import PropTypes from 'prop-types';
import {_truncateDomainName} from "../../common/helpers/HelperFunc";

import SelectPrice from "../../common/primitives/SelectPrice";
import Button from "../../common/primitives/Button";
import Label from "../../common/primitives/Label";
import Price, {ConvertToEUR} from "../../common/primitives/Price";

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import styles from "./CartLines.scss";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import LoadingRow from "../../common/primitives/LoadingRow";
import {__t} from '../../common/lang/text-resource';

const CartLinePlan = ({
						  data,
						  taxonomy,
						  removeService,
						  changeServiceTerm,
						  toggleMainDomainSelect,
						  childServices,
						  showAsPage,
						  hasMultipleDomains
					  }) => {
	const {
		id,
		serviceName,
		serviceTypeName,
		serviceType,
		serviceId,
		mainDomainData,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		isNewService,
		isRenewService,
		canDelete,
		showPriceSelector,
		term,
		currency,
		priceOrig,
		loading,
		priceTopOrig,
	} = data;

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}
	const showSecondRow = (mainDomainData !== undefined && mainDomainData.length !== 0) || (discountPriceList > 0 || discountPromo > 0 || discountTerm > 0);
	let tmpName = serviceName;
	if (serviceType === 'Plan') {
		tmpName = `${serviceTypeName.replace('план', '')} ${serviceName}`;
	}
	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={tmpName}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>
				  {
					  showPriceSelector === true && showAsPage === true ?

						<SelectPrice
						  name={id}
						  newPriceCol="price"
						  valueCol="priceId"
						  labelCol="term"
						  options={priceData}
						  oldPriceCol="oldPrice"
						  currencyCol="currency"
						  selected={servicePriceId}
						  onChange={changeServiceTerm}
						  onMenuOpen={() => {
							  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
						  }}/>
						:
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										priceOrig !== priceTopOrig ? priceTopOrig : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											priceOrig !== priceTopOrig ? ConvertToEUR(priceTopOrig) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout='padding-right--md'>&nbsp;</td>
							</tr>
							</tbody>
						</table>
				  }
			  </div>
		  </div>
		  {
			  showSecondRow ?
				<div data-layout="row gutter-none start" className={styles.discountsWrapper}>

					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*Редове с отстъпки начало*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					<div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>
						{
							(discountPriceList > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–-discountPriceList%-допълнителна-партньорска-отс17c357', {discountPriceList: discountPriceList})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountPromo > 0) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
								  </div>
							  </div>
							  : ''
						}

						{
							(discountTerm > 0 && discountPromo < 100) ?
							  <div data-layout="row gutter-none middle">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									data-layout="col 11 margin-top--xs padding-left--xs text-left"
									className={helpers.orderServiceDiscount}>
									  {isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
								  </div>
							  </div>
							  : ''
						}
					</div>
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*Редове с отстъпки край*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
					{
						showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
					}
					<div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Основен домейн начало*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{
							(isNewService && mainDomainData !== undefined && mainDomainData.length !== 0) ?
							  <div data-layout="row gutter-none middle margin-top--xxs">
								  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
								  <div
									className={styles.whNWTab}
									data-layout="col 11 margin-top--xs padding-left--xs text-left">
									  {__t('За:')}&nbsp;
									  {
										  hasMultipleDomains ?

											<Button
											  name={`main_domain_${id}`}
											  title={mainDomainData.name}
											  value={_truncateDomainName(mainDomainData.name, mainDomainData.domainTLD, 24)}
											  className={`${buttons.buttonLink} ${buttons.action}`}
											  onClick={toggleMainDomainSelect}/>
											: _truncateDomainName(mainDomainData.name, mainDomainData.domainTLD, 24)
									  }
								  </div>
							  </div>
							  : ''
						}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*Основен домейн край*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
						{/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

					</div>
				</div> : ''
		  }


		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (childServices) ?
				childServices.map((child, i) => {
					let serviceNameFormatted = child.serviceName;
					if (child.serviceType === 'IPADDRESS' && child.isRenewService) {
						serviceNameFormatted = `${child.serviceTypeName} (${child.serviceName})`;
					}

					let canDeleteInner = child.canDelete;
					if (child.serviceType === 'SpamExpert' && child.statusCode === 'S1') {
						canDeleteInner = false;
					}

					if (child.serviceType === 'WPSupport' && child.statusCode !== 'AUTO') {
						canDeleteInner = false;
					}

					return (
					  <div key={i} data-layout="row gutter-none middle margin-top--xxs">
						  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>
							  {
								canDeleteInner === true &&
								<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
										className={`${buttons.buttonImage} ${styles.removeButton}`}
										onClick={() => removeService(child.id, child.serviceId, child.serviceName)}>
									<img src={removeImg} alt={__t("Remove")}/>
								</button>
							  }
						  </div>
						  <div
							className={styles.childServiceContainer}
							data-layout={`col 11 margin-top--smm padding-left--xs text-left ${showAsPage ? '5@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td data-layout="text-left">
										  {
											  (child.serviceType !== 'CpanelLicensing' && (child.serviceType === 'BACKUP_SPACE' && child.quantity > 1)) ?
												`${child.quantity} ` : null
										  }

										  {(child.serviceType === 'RAM_VPS') ? 'MB ' :
											(child.serviceType === 'BACKUP_SPACE' && child.quantity > 1) ? 'GB ' :
											  (child.serviceType === 'IPADDRESS' && child.isRenewService !== true) ? (child.quantity === 1) ? __t('брой') : __t('броя') : ''}

										  {child.serviceType === 'SpamExpert' || child.serviceType === 'WPSupport' ?
											<span
											  title={child.serviceTypeName}>{child.serviceTypeName} - {child.serviceName}</span> :
											<span title={child.serviceName}>{serviceNameFormatted}</span>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						  <div
							className={styles.childServiceContainerPrice}
							data-layout={`col 11 margin-top--xs padding-left--xs text-left ${showAsPage ? '6@md' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td>
										  {term}
									  </td>
									  <td className={styles.oldPrice}>
										  {
											  child.priceOrig !== child.priceTopOrig ? child.priceTopOrig : null
										  }
										  {SHVO.showEuroPrices && <>
											  <br/>
											  {
												  child.priceOrig !== child.priceTopOrig ? ConvertToEUR(child.priceTopOrig) : null
											  }
										  </>}
									  </td>
									  <td>
										  <Price
											currency={child.currency}
											value={child.price}
											currencyClass={styles.currency}/>
										  {SHVO.showEuroPrices && <>
											  <br/>
											  <Price
												currency={'EUR'}
												value={ConvertToEUR(child.price)}
												currencyClass={styles.currency}/>
										  </>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>

						  {
							  (child.percentOff > 0) ?
								<div data-layout="col 12">
									<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
										<div
										  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left margin-right--20"
										  className={helpers.orderServiceDiscount}>
											{__t('-:percentOff% отстъпка', {percentOff: child.percentOff})}
										</div>
									</div>
								</div>
								: ''
						  }
					  </div>
					)
				})

				: undefined
		  }

		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

	  </section>
	);

};

CartLinePlan.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceType: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		servicePriceId: PropTypes.string.isRequired,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		canDelete: PropTypes.bool,
		showPriceSelector: PropTypes.bool,
		term: PropTypes.string,
		oldPrice: PropTypes.string,
		price: PropTypes.string,
		priceOrig: PropTypes.string,
		currency: PropTypes.string,
		mainDomainData: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
			domainTLD: PropTypes.string,
			isCyrillic: PropTypes.bool,
			lineId: PropTypes.string,
			name: PropTypes.string,
		})]),
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		),
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
	}),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	toggleMainDomainSelect: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool,
	childServices: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
		quantity: PropTypes.string,
		serviceType: PropTypes.string,
		currency: PropTypes.string,
		price: PropTypes.string,
	})]),
	hasMultipleDomains: PropTypes.bool
};

export default CartLinePlan;
